<template>
  <div class="col-md-8">
    <div class="card">
      <div class="card-header">
        <!-- <h4 class="card-title mb-0">Historial Plantillas</h4>
        <div class="card-options text-right">demo</div> -->
        <div class="header-top">
          <h4 class="m-0">Lista Asistencia</h4>
          <div class="card-header-right-icon">
            <!-- <button class="btn btn-primary" @click="allCertificate">
              <i class="fa fa-download">Descargar Todos</i>
            </button> -->
            <button class="btn btn-primary" @click="generateAllCertificates">
              <i class="fa fa-download">Descargar Todos</i>
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive add-project">
        <table class="table card-table table-vcenter text-nowrap">
          <thead>
            <tr>
              <th class="text-center">#</th>
              <th>CI - Complemento</th>
              <th>Paterno</th>
              <th>Materno</th>
              <th>Nombre(s)</th>
              <th class="text-center">Asistió</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedItems" :key="item.id">
              <th class="text-center">
                {{ index + 1 + (currentPage - 1) * itemsPerPage }}
              </th>
              <td class="text-uppercase">{{ item.id_card }}</td>
              <td class="text-uppercase">{{ item.flast }}</td>
              <td class="text-uppercase">{{ item.slast }}</td>
              <td class="text-uppercase">{{ item.names }}</td>
              <td class="text-center text-uppercase">
                <div class="btn-group mr-2">
                  <button
                    class="btn btn-success"
                    @click="generateCertificateByParticipant(item.id)"
                    v-if="item.is_attendance"
                  >
                    <i class="fa fa-download"></i> Certificado
                  </button>
                  <!-- <button
                    class="btn btn-success"
                    @click="getCertificateByUser(item.id)"
                    v-if="item.is_attendance"
                  >
                    <i class="fa fa-download"></i> Certificado
                  </button> -->
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, inject } from "vue";
import axios from "@/includes/connection";

const swal = inject("$swal");

// openModal
const emit = defineEmits(["openModal", "reload"]);
const props = defineProps({ list: Array, eventId: numeric });
const showModal = () => {
  //console.log("open modal");
  emit("openModal");
};

const list = computed(() => {
  return props.list;
});

import { useRouter } from "vue-router";
import { numeric } from "@vee-validate/rules";
const router = useRouter();

//--- access to param
const qparams = router.params;

const eventId = computed(() => {
  return props.eventId;
});

//---------- Generate all certificates back --------------------

const allCertificate = async () => {
  //console.log("params", eventId.value);
  const info = { eventId: props.eventId };
  const fileName = "all_certificates";
  try {
    const response = await axios.post(`/certification/generate-all`, info, {
      responseType: "blob", // Important for handling binary data
    });

    // Create a URL for the blob and download it
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName + ".pdf"); // Use the actual file name
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
    //console.log("error code", error.response.status);
    switch (error.response.status) {
      case 401:
        swal.fire({
          icon: "error",
          title: "Modelo de certificado no encontrado",
          text: "El evento aun no cuenta con un modelo de certificado, por favor intentelo de nuevo mas tarde.",
          confirmButtonText: "Aceptar",
        });
        break;
      case 500:
        swal.fire({
          icon: "error",
          title: "Estamos reparaciones",
          text: "Lo sentimos, estamos experimentando dificultades técnicas.\nPor favor, inténtelo nuevamente mas tarde.\n Gracias por su comprensión.",
          confirmButtonText: "Aceptar",
        });
        break;
      default:
        swal.fire({
          icon: "error",
          title: "Algo salio mal",
          text: "Lo sentimos, estamos experimentando dificultades técnicas.\nPor favor, inténtelo nuevamente mas tarde.\n Gracias por su comprensión.",
          confirmButtonText: "Aceptar",
        });
        break;
    }
  }
};

//----------- Generate all certificates here by user(participant) --------------------
const generateAllCertificates = async () => {
  //console.log("params", eventId.value);
  const info = { eventId: props.eventId };
  const fileName = "all_certificates";
  try {
    const response = await axios.post(`/certification/info/generate-all`, info);
    //console.log("response", response.data);

    for (let i = 0; i < response.data.length; i++) {
      await generateCertificate(response.data[i]);
    }
  } catch (error) {
    console.error("Error downloading template:", error);
  }
};

//---------- Generate certificate back by user --------------------

const getCertificateByUser = async (userId) => {
  const info = { eventId: props.eventId, userId: userId };
  const fileName = "certificate";
  try {
    const response = await axios.post(`/certification/generate-by-user`, info, {
      responseType: "blob", // Important for handling binary data
    });

    // Create a URL for the blob and download it
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName + ".pdf"); // Use the actual file name
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
    switch (error.response.status) {
      case 401:
        swal.fire({
          icon: "error",
          title: "Modelo de certificado no encontrado",
          text: "El evento aun no cuenta con un modelo de certificado, por favor intentelo de nuevo mas tarde.",
          confirmButtonText: "Aceptar",
        });
        break;
      case 404:
        swal.fire({
          icon: "error",
          title: "Participante no encontrado",
          text: "No se encontro al participante",
          confirmButtonText: "Aceptar",
        });
        break;
      case 500:
        swal.fire({
          icon: "error",
          title: "Estamos reparaciones",
          text: "Lo sentimos, estamos experimentando dificultades técnicas.\nPor favor, inténtelo nuevamente mas tarde.\n Gracias por su comprensión.",
          confirmButtonText: "Aceptar",
        });
        break;
      default:
        swal.fire({
          icon: "error",
          title: "Estamos reparaciones",
          text: "Lo sentimos, estamos experimentando dificultades técnicas.\nPor favor, inténtelo nuevamente mas tarde.\n Gracias por su comprensión.",
          confirmButtonText: "Aceptar",
        });
        break;
    }
  }
};

//---------- Generate certificate here by user(participant) --------------------

const generateCertificateByParticipant = async (userId) => {
  const info = { eventId: props.eventId, userId: userId };
  const fileName = "certificate";
  try {
    const response = await axios.post(`/certification/info/by-user/`, info);
    //console.log("response", response.data);

    await generateCertificate(response.data);
  } catch (error) {
    console.error("Error ", error);
  }
};

//---pagination section
import Pagination from "@/pages/components/Pagination.vue";
import { generateCertificate } from "@/auth/components/certificate";
let currentPage = ref(1);
let itemsPerPage = ref(10);

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  return list.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>
